import React, { useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import './legalModal.scss';

const CLOSE_ANIMATION_DURATION = 280;

function LegalModal({ isOpen, onClose }) {
  const [isMounted, setIsMounted] = useState(isOpen);
  const [isClosing, setIsClosing] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsMounted(true);
      setIsClosing(false);
      return undefined;
    }

    if (!isMounted) {
      return undefined;
    }

    setIsClosing(true);
    const timeoutId = setTimeout(() => {
      setIsMounted(false);
      setIsClosing(false);
    }, CLOSE_ANIMATION_DURATION);

    return () => clearTimeout(timeoutId);
  }, [isMounted, isOpen]);

  useEffect(() => {
    if (!isMounted) {
      return undefined;
    }

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';

    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      document.body.style.overflow = previousOverflow;
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [isMounted, onClose]);

  if (!isMounted) {
    return null;
  }

  const modalStateClass = isClosing ? 'closing' : 'open';

  const handleOverlayClick = (event) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  return (
    <div
      className={`legal-modal-overlay ${modalStateClass}`}
      onClick={handleOverlayClick}
      role="presentation"
    >
      <div
        className={`legal-modal ${modalStateClass}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="legal-modal-title"
      >
        <button
          type="button"
          className="legal-modal-close"
          onClick={onClose}
          aria-label="Fermer les mentions l\u00e9gales"
        >
          <FontAwesomeIcon icon={faTimes} />
        </button>

        <div className="legal-modal-content">
          <h2 id="legal-modal-title">Mentions légales</h2>

          <section>
            <h3>Éditeur du site</h3>
            <p>Le présent site est édité par La Houblonnière de Lezerzot</p>
            <p>Siège social : 3 Lezerzot, 22140 Bredily, France</p>
            <p>SIRET : 839 377 017 00018</p>
            <p>
              Adresse e-mail :{' '}
              <a href="mailto:houblon.lezerzot@hotmail.com">
                houblon.lezerzot@hotmail.com
              </a>
            </p>
          </section>

          <section>
            <h3>Directeur de la publication</h3>
            <p>La Houblonnière de Lezerzot</p>
          </section>

          <section>
            <h3>Hébergement</h3>
            <p>Le site est hébergé par :</p>
            <p>Vercel Inc.</p>
            <p>440 N Barranca Ave #4133, Covina, CA 91723, États-Unis</p>
            <p>
              Site web : <a href="https://vercel.com" target="_blank" rel="noopener noreferrer">vercel.com</a>
            </p>
            <p>Nom de domaine enregistré auprès de Gandi.</p>
          </section>

          <p className="legal-modal-credit">Créé par Bruce Traccard</p>
        </div>
      </div>
    </div>
  );
}

export default LegalModal;
